var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-image", { attrs: { src: _vm.src, fit: _vm.fit } }, [
    _c(
      "div",
      { staticClass: "t-image-slot", attrs: { slot: "error" }, slot: "error" },
      [_c("i", { staticClass: "el-icon-picture-outline" })]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }